import ChatbotPopupTab from "./chatbot-popup-tab";
import DefaultTab from "./default-tab";
import UniversityTab from "./university-tab";

export default { ChatbotPopupTab, DefaultTab, UniversityTab };
